import React from "react";
import { User, Briefcase, Mail, Phone } from "lucide-react";
import { references } from "../data/mock";

const References = () => {
  return (
    <section id="references" className="relative py-24 lg:py-32 border-t border-teal-500/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl mb-14">
          <div className="inline-flex items-center gap-2 text-xs font-mono uppercase tracking-[0.2em] text-teal-400 mb-4">
            <span className="w-8 h-px bg-teal-400" /> 08 — References
          </div>
          <h2 className="font-display text-4xl lg:text-5xl font-bold leading-tight">
            People who can <span className="text-teal-300">vouch for my work</span>.
          </h2>
          <p className="mt-4 text-slate-400">
            Available upon request. Feel free to reach out to any of the following.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {references.map((ref) => (
            <div
              key={ref.name + ref.company}
              className="rounded-2xl border border-teal-500/15 bg-[#08201d]/60 p-6 hover:border-teal-400/40 transition-colors flex flex-col gap-4"
            >
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-lg bg-teal-500/15 text-teal-300 flex items-center justify-center shrink-0">
                  <User className="w-5 h-5" />
                </div>
                <div className="min-w-0">
                  <div className="font-display font-semibold text-slate-100 truncate">{ref.name}</div>
                  <div className="text-sm text-teal-300 font-mono mt-0.5 truncate">{ref.title}</div>
                </div>
              </div>

              <div className="space-y-2 text-sm text-slate-400">
                <div className="flex items-center gap-2">
                  <Briefcase className="w-4 h-4 text-teal-500/60 shrink-0" />
                  <span className="truncate">{ref.company} · {ref.relationship}</span>
                </div>
                {ref.email && (
                  <div className="flex items-center gap-2">
                    <Mail className="w-4 h-4 text-teal-500/60 shrink-0" />
                    <a
                      href={`mailto:${ref.email}`}
                      className="truncate hover:text-teal-300 transition-colors"
                    >
                      {ref.email}
                    </a>
                  </div>
                )}
                {ref.phone && (
                  <div className="flex items-center gap-2">
                    <Phone className="w-4 h-4 text-teal-500/60 shrink-0" />
                    <a
                      href={`tel:${ref.phone}`}
                      className="hover:text-teal-300 transition-colors"
                    >
                      {ref.phone}
                    </a>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default References;
